import React from 'react';
import { UtensilsCrossed, Stethoscope, Scale, ShoppingCart, Home, Monitor } from 'lucide-react';

const Industries = () => {
  const industries = [
    {
      icon: UtensilsCrossed,
      title: "Restaurants & Food",
      description: "Take orders, handle reservations, answer menu questions, and manage delivery inquiries 24/7.",
      useCases: ["Take orders", "Book tables", "Menu questions", "Delivery tracking"]
    },
    {
      icon: Stethoscope,
      title: "Medical & Healthcare",
      description: "Schedule appointments, verify insurance, send reminders, and handle basic patient questions.", 
      useCases: ["Book appointments", "Insurance help", "Prescription refills", "Office hours"]
    },
    {
      icon: Scale,
      title: "Legal & Professional",
      description: "Qualify leads, book consultations, explain services, and answer common legal questions.",
      useCases: ["Book consultations", "Service info", "Pricing questions", "Case types"]
    },
    {
      icon: ShoppingCart,
      title: "E-commerce & Retail",
      description: "Answer product questions, track orders, handle returns, and recover abandoned carts.",
      useCases: ["Product help", "Order status", "Return requests", "Size guides"]
    },
    {
      icon: Home,
      title: "Real Estate",
      description: "Qualify buyers, schedule viewings, share property info, and connect with right agents.",
      useCases: ["Property details", "Schedule tours", "Neighborhood info", "Mortgage help"]
    },
    {
      icon: Monitor,
      title: "Software & Tech",
      description: "Provide technical support, explain features, handle billing, and onboard new users.",
      useCases: ["Technical help", "Feature questions", "Billing support", "Account setup"]
    }
  ];

  return (
    <>
    <div className="thunder-divider">
      <svg className="thunder-line" viewBox="0 0 100 20" preserveAspectRatio="none">
        <path d="M0,10 L15,10 L20,4 L25,16 L30,7 L35,13 L40,5 L45,15 L50,8 L55,12 L60,6 L65,14 L70,9 L75,11 L80,3 L85,17 L90,10 L100,10" stroke="currentColor" fill="none" strokeWidth="2"/>
      </svg>
    </div>
    <section id="industries" className="section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Perfect for your business</h2>
          <p className="section-subtitle">
            Whether you run a restaurant, law firm, or online store - your AI assistant knows exactly what your customers need.
          </p>
        </div>
        <div className="grid grid-3">
          {industries.map((industry, index) => {
            const IconComponent = industry.icon;
            return (
              <div key={index} className="card">
                <div className="card-icon">
                  <IconComponent size={32} />
                </div>
                <h3>{industry.title}</h3>
              <p style={{ marginBottom: '1.5rem' }}>{industry.description}</p>
              <div>
                <h4 style={{ fontSize: '0.875rem', fontWeight: 600, color: '#4a5568', marginBottom: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                  Common Use Cases:
                </h4>
                <ul style={{ listStyle: 'none', padding: 0, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  {industry.useCases.map((useCase, idx) => (
                    <li key={idx} style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      marginBottom: '0.5rem',
                      fontSize: '0.9rem',
                      color: '#647491'
                    }}>
                      <span style={{ 
                        width: '6px', 
                        height: '6px', 
                        background: '#0566FF', 
                        borderRadius: '50%', 
                        marginRight: '0.75rem' 
                      }}></span>
                      {useCase}
                    </li>
                  ))}
                </ul>
              </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
    </>
  );
};

export default Industries;